import { IdConta } from "../common-types";
import { GenericService } from "../generic-service";
import { ResponseInbox } from "../inbox/inbox.service";
import { ResponseUsuario } from "../usuarios/usuarios.service";

export type CreateConta = {
  nome: string;
  numeroUsuariosContratados: number;
}

export type DefaultBoardNames = {
  fila?: string;
  'em-andamento'?: string;
}

export type UpdateConta = Partial<CreateConta> & { id: IdConta; defaultBoardNames?: DefaultBoardNames }

export type ResponseConta = {
  id: IdConta;
  nome: string;
  numeroUsuariosContratados: number;

  dataCriacao: string;
  dataSuspensao: string | null;
  del: boolean;

  integracaoAxionAtiva?: boolean;
  idUsuarioAxion?: string | null;
  // Base da instalação AXION da conta. Usada para montar o link da sala de reunião
  // no próprio front (o token da integração nunca sai do servidor).
  urlAxion?: string | null;

  defaultBoardNames?: DefaultBoardNames;

  onboardingStep?: number | null;

  // TODO(backend): este campo ainda não é enviado pela API. Precisa ser exposto em
  // GET /contas/:id (e no payload de login/sessão) quando o módulo Clone passar a ser
  // um produto contratável. Até lá, useCloneAccess() trata `undefined` como "sem acesso".
  clonePurchased?: boolean;

  usuarios: ResponseUsuario[];
  inboxes: ResponseInbox[];
};

export type ResponseIntegracaoAxionAdmin = {
  integracaoAxionAtiva: boolean;
  urlAxion: string | null;
  hasToken: boolean;
};

export type UpdateIntegracaoAxionAdmin = {
  url?: string;
  token?: string;
  integracaoAxionAtiva?: boolean;
};

export class ContasService extends GenericService<CreateConta, UpdateConta, ResponseConta> {
  constructor() { super('contas') }

  async getUsuariosVinculados(idConta: string): Promise<ResponseUsuario[]> {
    return await this.f.get(`/${idConta}/usuarios`) as ResponseUsuario[];
  }

  async desvincularUsuarios(idConta: string, idUsuarioArray: string[]): Promise<void> {
    return await this.f.delete(`/${idConta}/usuarios`, {idsUsuarios: idUsuarioArray}) as void;
  }

  async vincularUsuarios(idConta: string, idUsuarioArray: string[]): Promise<void> {
    return await this.f.post(`/usuarios`, {idsContas: [idConta], idsUsuarios: idUsuarioArray}) as void
  }

  async getInboxesVinculados(idConta: string): Promise<ResponseInbox[]> {
    return await this.f.get(`/${idConta}/inboxes`) as ResponseInbox[];
  }

  async getIntegracaoAxion(idConta: string): Promise<ResponseIntegracaoAxionAdmin> {
    return await this.f.get(`/${idConta}/integracao-axion`) as ResponseIntegracaoAxionAdmin;
  }

  async updateIntegracaoAxion(idConta: string, dto: UpdateIntegracaoAxionAdmin): Promise<void> {
    return await this.f.patch(`/${idConta}/integracao-axion`, dto) as void;
  }

  async updateOnboardingStep(idConta: string, step: number | null): Promise<void> {
    await this.f.patch(`/${idConta}/onboarding-step`, { step });
  }

  /** Congela (true) ou descongela (false) a aplicação da conta. */
  async updateCongelamento(idConta: string, congelada: boolean): Promise<void> {
    await this.f.patch(`/${idConta}/congelamento`, { congelada });
  }

}